import {observable, action} from 'mobx'
import {api} from 'helpers/Api'
import {ICrudStore} from 'Store'
import {Family} from './Model'

export default class implements ICrudStore<Family> {
  @observable families: Family[] = []
  @observable loaded: boolean = false

  read(id?: number): any /* tslint:disable-line:no-any */ {
    if (id) return api.get('family/' + id).then(family => new Family(family))
    return api.get('family').then(this.set)
  }

  create(family: Family) {
    return api.post('family', family)
  }

  update(id: number, family: Family) {
    return api.put('family/' + id, family)
  }

  delete(id: number) {
    return api.delete('family/' + id)
  }

  @action
  private set = (families: Family[]) => {
    this.families = families.map(family => new Family(family))
    this.loaded = true
    return families
  };
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/modules/Families/Store.ts